import { render, staticRenderFns } from "./SelfPickupGoodsRiderEfficiencyList.vue?vue&type=template&id=5360428f&scoped=true"
import script from "./SelfPickupGoodsRiderEfficiencyList.vue?vue&type=script&lang=js"
export * from "./SelfPickupGoodsRiderEfficiencyList.vue?vue&type=script&lang=js"
import style0 from "./SelfPickupGoodsRiderEfficiencyList.vue?vue&type=style&index=0&id=5360428f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360428f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5360428f')) {
      api.createRecord('5360428f', component.options)
    } else {
      api.reload('5360428f', component.options)
    }
    module.hot.accept("./SelfPickupGoodsRiderEfficiencyList.vue?vue&type=template&id=5360428f&scoped=true", function () {
      api.rerender('5360428f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryEffiRider/SelfPickupGoodsRiderEfficiencyList.vue"
export default component.exports